import React from 'react';
import { FadeIn } from './FadeIn';
export function Guarantee() {
  return <section className="py-8 md:py-20 px-4 bg-gradient-to-br from-kid-lime/5 via-white to-kid-sky/5 relative overflow-hidden" data-id="element-148">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-149">
        <FadeIn data-id="element-150">
          <div className="bg-white rounded-2xl p-6 md:p-16 shadow-sm border border-kid-lime/50 text-center flex flex-col items-center relative overflow-hidden" data-id="element-151">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-kid-lime via-kid-sky to-kid-purple" data-id="element-152"></div>
            <img src="https://cdn.magicpatterns.com/uploads/qYiFGSSSH6iWgdabfSMMBE/20260305_0735_Image_Generation_simple_compose_01kjys26fgfqa9dksd7kzky4gg_(1).webp" alt="Garantía 7 Días - 100% Satisfacción o Devolución" className="w-24 h-24 md:w-40 md:h-40 object-contain mb-4 md:mb-6" data-id="element-153" />
            <h2 className="text-xl md:text-3xl font-bold text-gray-900 mb-2 md:mb-3" data-id="element-154">
              Garantía de satisfacción.
            </h2>
            <p className="text-sm md:text-base text-gray-500 font-medium" data-id="element-155">
              Podés revisar todo el material con tranquilidad.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}